import { gatewayOrigin } from "@/lib/gateway-origin";

/** Build the public gateway URL for a per-connection chat webhook. */
export function connectionWebhookUrl(
	connectionSlug: string,
	env: ImportMetaEnv = import.meta.env,
	pageOrigin: string | undefined = typeof window !== "undefined"
		? window.location.origin
		: undefined,
): string {
	const runtimeId = connectionSlug.startsWith("agentconn-")
		? connectionSlug.slice("agentconn-".length)
		: connectionSlug;
	return `${gatewayOrigin(env, pageOrigin)}/lobu/api/v1/webhooks/${encodeURIComponent(runtimeId)}`;
}
